import { Suspense } from 'react';
import { Box, MantineColor, MantineSpacing } from '@mantine/core';
import { AppBreadcrumbs } from './AppBreadcrumbs';
import { ContentPaneOverlayProvider, ContentPaneOverlaySlot } from './ContentPaneOverlay';
import PageLoader from 'src/UI/loader/PageLoader';

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  bg?: MantineColor;
  p?: MantineSpacing;
};

export function AppContentPane({ children, style, bg, p }: Props) {
  return (
    <ContentPaneOverlayProvider>
      <Box
        h="100%"
        pos="relative"
        style={{
          backgroundColor: 'rgba(255, 119, 28, 0.4)',
          borderRadius:
            'var(--mantine-spacing-xxl) var(--mantine-spacing-xxl) var(--mantine-spacing-xxxl) var(--mantine-spacing-xxxl)',
          overflow: 'hidden',
          flex: 1,
          minWidth: 0,
          ...style,
        }}
      >
        <ContentPaneOverlaySlot />
        <Box
          bg={bg ?? 'contentBackground'}
          px={p ?? 'xxl'}
          py={p ?? 'lg'}
          h="100%"
          w="100%"
          style={{
            borderRadius:
              'var(--mantine-spacing-xxl) var(--mantine-spacing-xxl) var(--mantine-spacing-xxxl) var(--mantine-spacing-xxxl)',
            overflow: 'auto',
            overscrollBehavior: 'contain',
          }}
        >
          <AppBreadcrumbs />
          <Suspense fallback={<PageLoader absolute={false} />}>{children}</Suspense>
        </Box>
      </Box>
    </ContentPaneOverlayProvider>
  );
}
